import Sidebar from '../components/sidebar/Sidebar';
import React, {useState} from 'react';
import Footer from '../components/footer/Footer';
import Forms1099Details from "../components/forms/Forms1099Details";
import NavbarForms from "../components/navbar/NavbarForms";


const Forms1099 = () => {

    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => {
        setIsOpen(!isOpen);
    }

    return (
      <>
        <Sidebar isOpen={isOpen} toggle={toggle} />
        <NavbarForms toggle={toggle} />
          <Forms1099Details/>
        <Footer/>
      </>
  );
};

export default Forms1099;
